import { useState, useEffect } from "react";
import { getHomeData } from "@/api/homeApi";

export default function CtaSection() {
  const [clientLogos, setClientLogos] = useState<string[]>([]);

  useEffect(() => {
    getHomeData().then((res: any) => {
      if (res.clientLogos) setClientLogos(res.clientLogos.map((c: any) => c.name));
    }).catch(() => {});
  }, []);
  return (
    <section className="py-10 lg:py-20 bg-[#F4F7FC]" id="cta">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-5xl font-bold text-[#0d1f3c] mb-5 leading-tight">
            准备好让欧格登智能保护您的企业了吗？
          </h2>
          <p className="text-[#555555] text-base lg:text-lg mb-8 max-w-2xl mx-auto">
            欧格登专业团队 7×24 小时待命，立即获取定制化企业安全解决方案与报价，首次咨询完全免费。
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="#contact-form"
              className="px-10 py-4 bg-[#1a56db] hover:bg-[#1e40af] text-white font-semibold rounded-full transition-all duration-200 text-base whitespace-nowrap cursor-pointer"
            >
              免费获取安全方案
            </a>
            <a
              href="tel:400-888-9999"
              className="px-10 py-4 border border-[#1a56db]/30 hover:border-[#1a56db] text-[#1a56db] font-semibold rounded-full transition-all duration-200 text-base whitespace-nowrap cursor-pointer flex items-center justify-center gap-2 bg-white"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line text-sm"></i>
              </div>
              400-888-9999
            </a>
          </div>
        </div>

        {/* Client logos */}
        <div className="border-t border-[#1a56db]/10 pt-10">
          <p className="text-center text-gray-400 text-sm mb-6">欧格登智能已服务众多行业头部企业</p>
          <div className="flex flex-wrap items-center justify-center gap-6 lg:gap-10">
            {clientLogos.map((logo) => (
              <div
                key={logo}
                className="px-5 py-2.5 bg-white border border-gray-200 rounded-lg text-gray-500 text-sm font-medium hover:text-[#1a56db] hover:border-[#1a56db]/30 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                {logo}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
